import { useState } from "react";
import {
  Form,
  Input,
  Button,
  Alert,
  Typography,
  message,
  Divider,
  Switch,
} from "antd";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import { UserAddOutlined } from "@ant-design/icons";
import streenLogo from "../../img/logo.png";

const { Title } = Typography;

const SingleUserRegister = () => {
  const [loading, setLoading] = useState(false);
  const [useCustomPassword, setUseCustomPassword] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onFinish = async () => {
    setLoading(true);
    setError(null);

    try {
      const payload = { username, email };

      if (useCustomPassword) {
        payload.password = password;
      }

      const res = await axios.post("/api/auth/register", payload);

      setResult({
        username: res.data.username,
        password: res.data.generated_password || password,
        qr: res.data.qr_code,
      });

      message.success("Benutzer erfolgreich registriert");
    } catch (err) {
      setError(err.response?.data || "Registrierung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 0" }}>
        {!result && (
          <Form
            style={{}}
            layout="vertical"
            onFinish={onFinish}
          >
            <Title level={2}>
              <span>
                <UserAddOutlined /> Registrieren
              </span>
            </Title>
            <Divider />

            <Form.Item
              label="👤 Benutzername"
              name="username"
              rules={[{ required: true, message: "Benutzername fehlt" }]}
            >
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="📧 Email"
              name="email"
              rules={[
                { required: true, message: "Email fehlt" },
                { type: "email", message: "Ungültige Email" },
              ]}
            >
              <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>

            <Form.Item label="Eigenes Passwort verwenden">
              <Switch
                checked={useCustomPassword}
                onChange={setUseCustomPassword}
              />
            </Form.Item>

            {useCustomPassword && (
              <Form.Item
                label="🔒 Passwort"
                name="password"
                rules={[{ required: true, message: "Passwort fehlt" }]}
              >
                <Input.Password
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
            )}

            <Form.Item style={{ textAlign: "center", padding: "20px 0" }}>
              {" "}
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={
                  !username ||
                  !email ||
                  (useCustomPassword && !password)
                }
                size="large"
              >
                {" "}
                Benutzer registrieren{" "}
              </Button>{" "}
            </Form.Item>

            {error && (
              <Alert
                style={{ marginTop: 16 }}
                type="error"
                message={error}
                showIcon
              />
            )}
          </Form>
        )}

        {result && (
          <div
            className="print-area"
            style={{
              textAlign: "center",
              marginTop: 24,
              padding: 24,
              border: "1px solid #ddd",
              borderRadius: 12,
              background: "#fff",
            }}
          >
            <img src={streenLogo} alt="STREEN" style={{ width: 100 }} />

            <p>
              <strong>Username:</strong> {result.username}
            </p>
            <p>
              <strong>Passwort:</strong> {result.password}
            </p>

            <QRCodeCanvas value={result.qr} size={120} />

            <div style={{ marginTop: 16 }}>
              <Button type="primary" onClick={() => window.print()}>
                Drucken
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={() => setResult(null)}>
                Neuen Benutzer
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleUserRegister;
